import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  BOOLEAN_FALSE,
  EMPTY_ARRAY,
  NUMBER_ONE,
  NUMBER_ZERO,
  SUGGESTED_ACTIONS_COLUMNS,
  TABLE_NAME_SUGGESTED_ACTIONS,
} from 'constants/constants';
import React, { useEffect, useState } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import classes from '../ecosystem-opportunity/ecosytemOpportunity.module.scss';
import SuggestionActionWarning from './SuggestionActionWarning';
import { useSelector } from 'react-redux';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';

const SuggestedActions = ({
  ecosystemOpportunityData = [],
  isMandatoryFiltersSelected,
}) => {
  const selectedEcoOppRegion = useSelector(
    (state) =>
      state.CustomerView?.ecosystemOpportunityFilters?.EcoOppRegion
        .selectedValue
  );
  const selectedEcoOppEcosystemName = useSelector(
    (state) =>
      state.CustomerView?.ecosystemOpportunityFilters?.EcoOppEcosystemName
        .selectedValue
  );
  const ecosystemTooltip = (
    <Tooltip className='gne-tooltip'>
      <span>
        The ecosystems are categorized into priority statuses based on the
        opportunity for pull-through given Parent Payer contribution and access
        position in the ecosystem, and further ranked in terms of relative
        priority. National averages are used for benchmarking purposes to
        identify opportunity and learning segments.
      </span>
    </Tooltip>
  );

  const [isShowWarning, setIsShowWarning] = useState(true);
  const [suggestedActionsData, setSuggestedActionsData] = useState([]);

  // This runs whenever the data or filters change
  useEffect(() => {
    if (isMandatoryFiltersSelected) {
      setIsShowWarning(false);
      setSuggestedActionsData(ecosystemOpportunityData);
    } else {
      setIsShowWarning(true);

      // Clear the table data (show empty table)
      setSuggestedActionsData(EMPTY_ARRAY);
    }
  }, [
    ecosystemOpportunityData,
    selectedEcoOppEcosystemName,
    selectedEcoOppRegion,
    isMandatoryFiltersSelected,
  ]);

  const size = { x: 1000, y: 400 };
  return (
    <div className={`${classes.opportunityContainer}`}>
      <div className='text text__bold ps-2 pt-4 title__large'>
        Suggested Actions
        <OverlayTrigger overlay={ecosystemTooltip}>
          <i className='icon icon__info__gray ms-2'></i>
        </OverlayTrigger>
      </div>
      <Row id='PolicyDetail'>
        <Col
          className='p-0'
          xs={12}>
          <ConfigurableTable
            rows={
              ecosystemOpportunityData?.length > NUMBER_ZERO
                ? suggestedActionsData
                : EMPTY_ARRAY
            }
            columns={SUGGESTED_ACTIONS_COLUMNS}
            exportFileName='suggestedActions'
            tableName={TABLE_NAME_SUGGESTED_ACTIONS}
            actionColumnWidth={NUMBER_ONE}
            dimentions={size}
            pagination={BOOLEAN_FALSE}
            showWarning={isShowWarning}
            customEmptyComponent={<SuggestionActionWarning />}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SuggestedActions;
